import React from 'react';
import { PropTypes } from 'prop-types';

import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

const LastImage = ({ styles }) => {
    const image = useStaticQuery(graphql`
        query {
            file(relativePath: { eq: "hp/case-studies/img_other_references_last.png" }) {
                childImageSharp {
                    fluid(quality: 90, cropFocus: SOUTHWEST, maxWidth: 606, maxHeight: 611) {
                        ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                }
            }
        }
    `);

    const {
        file: {
            childImageSharp: { fluid },
        },
    } = image;

    return (
        <div className={styles.container}>
            <Img className={styles.image} fluid={fluid} />
        </div>
    );
};

LastImage.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
};

export default LastImage;
